import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Icon = styled(({ mini, name, ...restProps }) => (
  <i {...restProps} className={`tcst-${name} ${restProps.className}`} />
))`
  font-size: 140%;
  vertical-align: middle;
  margin-right: ${props => (props.mini ? 0 : '4px')};
  line-height: 14px !important;
`;

class TCIcon extends Component {
  render() {
    const { name } = this.props;
    return <Icon name={name} />;
  }
}

export default TCIcon;
